const RouteSYS = [
    {
        name: 'Erreur',
        path: '/erreur',
        component: () => import('@common/components/ulaval-custom/Erreur.vue')
    },
    {
        name: 'Maintenance',
        path: '/maintenance',
        component: () => import('@common/components/ulaval-custom/Maintenance.vue')
    },
    {
        path: '/test',
        component: () =>
            import('../layouts/full-layout/FullLayout.vue'),
        /*children: [
            {
                name: 'TwigLand',
                path: '/twig/:twigPage(.*)',
                component: () => import('@common/views/twig/TwigLand.vue')
            }
        ]*/
    }
]

export default RouteSYS